const e = "_overlay_13z31_1", s = "_window_13z31_14", _ = "_modalSlideUp_13z31_1", a = "_header_13z31_47", t = "_close_13z31_61", o = "_content_13z31_69", n = "_messages_13z31_82", m = "_message_13z31_82", g = {
  overlay: e,
  window: s,
  modalSlideUp: _,
  header: a,
  close: t,
  content: o,
  messages: n,
  "messages--date": "_messages--date_13z31_91",
  message: m,
  "message--avatar": "_message--avatar_13z31_104",
  "message--details": "_message--details_13z31_140",
  "message--author": "_message--author_13z31_148",
  "message--text": "_message--text_13z31_151",
  "message--time": "_message--time_13z31_155",
  "loading-container": "_loading-container_13z31_181",
  "message-input-field": "_message-input-field_13z31_190"
};
export {
  t as close,
  o as content,
  g as default,
  a as header,
  m as message,
  n as messages,
  _ as modalSlideUp,
  e as overlay,
  s as window
};
